import { render, staticRenderFns } from "./ListaServicos.vue?vue&type=template&id=38ec3335&scoped=true"
import script from "./ListaServicos.vue?vue&type=script&lang=js"
export * from "./ListaServicos.vue?vue&type=script&lang=js"
import style0 from "./ListaServicos.vue?vue&type=style&index=0&id=38ec3335&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec3335",
  null
  
)

export default component.exports